import React from 'react';
import { SearchHeroBannerCarouselItemStyles as S } from './SearchHeroBannerCarouselItem.styles';
import { imageUrl } from '@helpers/imageUrl';
const SearchHeroBannerCarouselItem = ({ active, image, index, }) => {
    return (React.createElement(S.Container, { initial: active ? 'visible' : 'hidden', animate: active ? 'visible' : 'hidden', variants: { hidden: { opacity: 0 }, visible: { opacity: 1 } } },
        React.createElement(S.Image, { src: imageUrl(image.src, { width: 1920, dpr: 1 }), width: 1920, height: 1080, loading: index === 0 ? 'eager' : 'lazy' })));
};
export default SearchHeroBannerCarouselItem;
